import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from "@angular/core";
import { useTranslationNamespace } from "@logex/framework/lg-localization";
import { Subject } from "rxjs";
import { FLAGS_MENU_DEFINITION, IFlag } from "./types";

@Component({
    selector: "flags-menu-popup",
    templateUrl: "./flags-menu-popup.component.html",
    providers: [useTranslationNamespace("APP._Variation.CostDiffIndicators")],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FlagsMenuPopupComponent {
    @HostBinding("class") hostClass = "lg-dropdown-popup";

    @Input() currentId: number;
    @Input() optionsList: IFlag[];
    readonly currentChanged$ = new Subject<number>();

    constructor() {
        const params = inject(FLAGS_MENU_DEFINITION);

        this.currentId = params.current;
        this.optionsList = params.definition.slice(1, params.definition.length).sort((a, b) => {
            if (b.code === 0) return 1;
            else return (a.type || a.type === null) < (b.type || b.type === null) ? -1 : 1;
        });
        this.optionsList.push(params.definition[0]);
    }

    onClick(event: MouseEvent, value: IFlag) {
        event.stopPropagation();

        this.currentChanged$.next(value.code);
        return false;
    }
}
